<template>
  <div>
  <loadingCube v-if="!loaded" :loadingMessage="'GEOTEC'"></loadingCube>
  <div v-if="loaded" class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          GeoTec Live Data
        </div>
        <div class="card-body">
            <datatable  :type="'geotec'"
                        :rowData="locations" 
                        :loadingMessage="loadingMessage"
                        :noRowsMessage="noRowsMessage" 
                        :columns="columns"
                        :pagination-size="50">
            </datatable>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
  
<script>
import loadingCube from "loaders/record_loader";
import datatable from "datatables/datatable";
export default {
  name: "clock_in_out_locations",
  components: {
    loadingCube,
    datatable
  },
  data() {
    return {
      companyId: this.$store.state.auth.me.contact.company_id,
      locations: [],
      loaded: false,
      loadingMessage: 'Loading locations ...',
      noRowsMessage: 'No active locations found',
      columns: [
        { headerName: 'Location Name', field: 'shortLocationName', minWidth: 150},
        { headerName: 'Workers Required', field: 'workersRequired', cellStyle: { 'justify-content': "center" }},
        { headerName: 'Workers Assigned', field: 'workersAssigned', cellStyle: { 'justify-content': "center" }},
        { headerName: 'Workers On Site', field: 'workersOnSite', cellStyle: { 'justify-content': "center" }},
      ]
    };
  },
  beforeMount() {
    axios.get(this.crmApiPath + 'geo_tracking/get_active_locations/' + this.companyId).then(locations => {
      this.locations = locations.data;
      this.loaded = true;
    });
  },
  methods: {}
};
</script>